import { RequestTagInfo } from '../../SwapOrReturnTypes'
import { formatDateUTC } from 'src/utils/formatDate'
import * as S from './SwapOrReturnTag.styles'

interface Props {
  obj: RequestTagInfo
}

export const SwapOrReturnTag = ({ obj }: Props) => (
  <>
    <S.TagContainer data-testid='swap-or-return-tag-test-id'>
      <S.ContainerTitle>
        <S.TextHeader data-testid='title-test-id'>CONTROLE DE {obj.type.toUpperCase()}</S.TextHeader>
      </S.ContainerTitle>
      <S.ContainerInfo>
        <S.Text>Fornecedor:</S.Text>
        <S.DescriptionText data-testid='supplier-test-id'>{obj.supplier}</S.DescriptionText>
      </S.ContainerInfo>
      <S.ContainerInfo>
        <S.Text>Nº Nota:</S.Text>
        <S.DescriptionText data-testid='invoice-number-test-id'>{obj.invoiceNumber}</S.DescriptionText>
      </S.ContainerInfo>
      <S.ContainerInfos>
        <S.ContainerSubInfo position={S.ContainerSubInfoPositionEnum.LEFT}>
          <S.Text>Id Lote:</S.Text>
          <S.DescriptionText data-testid='id-batch-test-id'>{obj.idBatch}</S.DescriptionText>
        </S.ContainerSubInfo>
        <S.ContainerSubInfo position={S.ContainerSubInfoPositionEnum.RIGHT}>
          <S.Text>Cod. SKU:</S.Text>
          <S.DescriptionText data-testid='sku-code-test-id'>{obj.skuCode}</S.DescriptionText>
        </S.ContainerSubInfo>
      </S.ContainerInfos>
      <S.ContainerInfo>
        <S.Text>SKU:</S.Text>
        <S.DescriptionText data-testid='sku-test-id'>{obj.sku}</S.DescriptionText>
      </S.ContainerInfo>
      <S.ContainerInfos>
        <S.ContainerSubInfo position={S.ContainerSubInfoPositionEnum.LEFT}>
          <S.Text>Qtd.:</S.Text>
          <S.DescriptionText data-testid='quantity-test-id'>{obj.quantity} {obj.quantityUnit.toUpperCase()}</S.DescriptionText>
        </S.ContainerSubInfo>
        <S.ContainerSubInfo position={S.ContainerSubInfoPositionEnum.RIGHT}>
          <S.Text>Vol.:</S.Text>
          <S.DescriptionText data-testid='volume-test-id'>{obj.volume}L</S.DescriptionText>
        </S.ContainerSubInfo>
      </S.ContainerInfos>
      <S.ContainerInfo>
        <S.Text>Data de Validade:</S.Text>
        <S.DescriptionText data-testid='due-date-test-id'>{formatDateUTC(obj.dueDate, 'DD/MM/YYYY')}</S.DescriptionText>
      </S.ContainerInfo>
      <S.ContainerInfo>
        <S.Text>Operador:</S.Text>
        <S.DescriptionText data-testid='operator-test-id'>{obj.operator}</S.DescriptionText>
      </S.ContainerInfo>
      <S.ContainerInfo>
        <S.Text>Motivo:</S.Text>
        <S.DescriptionText data-testid='reason-test-id'>{obj.reason.toUpperCase()}</S.DescriptionText>
      </S.ContainerInfo>
      <S.ContainerAddress>
        <S.TextFooter size={18} data-testid='fulfillment-center-test-id'>{obj.fulfillmentCenter}</S.TextFooter>
        <S.AddressBlock>
          <S.TextFooter size={21} data-testid='address-test-id'>{obj.address}</S.TextFooter>
        </S.AddressBlock>
      </S.ContainerAddress>
    </S.TagContainer>
  </>
)
